module.exports = __webpack_public_path__ + "img/circles.3d76af4a.png";